/**
 * Test IDs for QA automation.
 */
export const testIds = {
  durationInputMinutes: "duration-input-minutes",
} as const;
